import CallbackLogin from './CallbackLogin';

export default CallbackLogin;
